// extracted by mini-css-extract-plugin
export default {"TableRow":"Marca_TableRow__8-lhr"};